/**
 * @module SmartForms
 * @description
 */
import React, { FC } from 'react';
import Script from 'next/script';
import styles from './OneTrust.module.css';

export const OneTrustOptOut = () => (
    <li
      id="ot-sdk-btn"
      className={ `ot-sdk-show-settings ${ styles.li }` }
      suppressHydrationWarning={ true }
    >
      Do Not Sell or Share My Personal Information
    </li>
);

const OneTrust: FC = () => {
  const dataDomain = 'f2982948-7112-43c4-834a-191657168573';
  const isDev = process.env.NODE_ENV !== 'production' ? '-test' : '';

  return (
    <Script
      src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
      type="text/javascript"
      strategy="beforeInteractive"
      data-domain-script={ `${ dataDomain }${ isDev }` }
      onLoad={ () => {
        const OptanonWrapper = () => {};
      }}
    />
  )

};

OneTrust.displayName = 'OneTrust';

export default OneTrust;
